export class RiskPermission {
    public RSK_Own: boolean = false;
    public RSK_Add_Unit: boolean = false;
    public RSK_Add: boolean = false;
    public RSK_Admin_Unit: boolean = false;
    public RSK_Admin: boolean = false;
    public RSK_View_Unit: boolean = false;
    public RSK_View: boolean = false;
}